import { CrudFilter, useList } from '@refinedev/core';
import { Family } from './useFamily';

export const useFamilies = (filters: { advisorUserId?: string } = {}) => {
  const crudFilters: CrudFilter[] = [];

  if (filters.advisorUserId) {
    crudFilters.push({
      field: 'advisorUserId',
      operator: 'eq',
      value: filters.advisorUserId,
    });
  }

  const { data, isLoading, isError, refetch } = useList<Family>({
    resource: 'families',
    filters: crudFilters,
  });

  return {
    families: data?.data || [],
    isLoading,
    isError,
    refetch,
  };
};
